import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { TerminosCondicionesComponent } from './terminos-condiciones.component';
import { MatIconModule } from '@angular/material/icon';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [TerminosCondicionesComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    NgbAccordionModule,
  ],
  exports: [TerminosCondicionesComponent],
})
export class TerminoscondicionesModule {}
